module.exports = __webpack_public_path__ + "img/spin_btn.5ccaf81e.png";